import React, { useState} from "react";
import {currencyConverter, generate_token, serverLink} from "../../url";
import axios from "axios";
import {showAlert} from "../../common/sweetalert/sweetalert";
import {connect} from "react-redux";
import Loader from "../../common/loader";
import {toast} from "react-toastify";
function Allergy(props) {
    const { patientSerial, patientName, walletAmount} = props;
    const token = props.loginData[0]?.token;
    const [IsLoading, setIsLoading] = useState(false)
    const [IsFormLoading, setIsFormLoading] = useState(false)


    const allergyInitial = {
        patientSerial: props.patientSerial,
        patientName: props.patientName,
        allergyName: "",
        allergyDescription: "",
        reactionImage: "",
        ImagePath: "",
        lastAttackDate: "",
        allergyMedication: "",
        durationBeforeSubsiding: "",
        submittedBy: `${props.loginData[0]?.userID}`,
    }
    const [formData, setFormData] = useState(allergyInitial)

    const resetFormData = () => {
      setFormData(allergyInitial)
    }

    const onEdit = async (e) => {
        setFormData({...formData, [e.target.id]: e.target.value})
    }

    const addAllergy = async () => {
        if (formData.allergyName.toString().trim() === ''){
            toast.error('Please enter allergy name')
            return false
        }
        if (formData.allergyMedication.toString().trim() === ''){
            toast.error('Please enter allergy medication')
            return false
        }
        if (formData.lastAttackDate.toString().trim() === ''){
            toast.error('Please enter last attack date')
            return false
        }

        setIsFormLoading(true)
        toast.info("please wait...");
        await axios.post(`${serverLink}patient/allergy/add`, formData, token).then(async (result) => {
            if (result.data.message === "success") {
                if (formData.ImagePath !== "") {
                    const formData2 = new FormData();
                    formData2.append('photo', formData.ImagePath);
                    formData2.append('entry_id', result.data.entry_id)
                    axios.patch(`${serverLink}patient/uploadAllergyPhoto`, formData2)
                        .then(async (res) => {
                            toast.success("Allergy Added Successfully");
                            setIsFormLoading(false);
                            props.setRebuildAllergy(generate_token(5));
                            document.getElementById("closeAllergy").click();
                            resetFormData()
                        })
                        .catch(err => {
                            setIsFormLoading(false);
                            showAlert(
                                "ERROR",
                                "Something went wrong uploading the image. Please try again!",
                                "error"
                            );
                        });
                }else{
                    toast.success("Allergy Added Successfully");
                    setIsFormLoading(false);
                    props.setRebuildAllergy(generate_token(5));
                    document.getElementById("closeAllergy").click();
                    resetFormData()
                }
            } else {
                setIsFormLoading(false);
                toast.error("Something went wrong adding appointment. Please try again!");
            }
        }) .catch((error) => {
            showAlert(
                "NETWORK ERROR",
                "Please check your connection and try again!",
                "error"
            );
        });
    }

    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setFormData({
                ...formData,
                ImagePath: event.target.files[0],
                ImageData: event.target.files[0],
            });
            // let reader = new FileReader();
            //     reader.onload = (e) => {
            //         this.setState({
            //             htmlelement: (
            //                 <div className="addpersonpage">
            //                     <img
            //                         className="netimage"
            //                         srcSet={e.target.result}
            //                         alt="profileImage"
            //                     />
            //                 </div>
            //             ),
            //         });
            //     };
            //     reader.readAsDataURL(event.target.files[0]);
        }
    };

    return IsLoading ? <Loader/> : <>
        <div id={`${
            typeof props.id !== "undefined" ? props.id : "responsive-modal"
        }`} className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style={{display: 'none'}}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header text-white" style={{backgroundColor: '#4b4949'}}>
                        <h2 className="modal-title" id="myLargeModalLabel">{props.title ?? ""}</h2>
                        <button type="button" className={`${
                            typeof props.close !== "undefined" ? props.close : "closeModal"
                        }`}  id={`${
                            typeof props.close !== "undefined" ? props.close : "close"
                        }`} data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-4 col-4 b-r"><strong>Patient Name</strong>
                                <br/>
                                <p className="text-muted">{patientName}</p>
                            </div>
                            <div className="col-md-4 col-4 b-r"><strong>Patient ID</strong>
                                <br/>
                                <p className="text-muted">{patientSerial}</p>
                            </div>
                            <div className="col-md-4 col-4 b-r"><strong>Wallet</strong>
                                <br/>
                                <p className="text-muted">{currencyConverter(walletAmount)}</p>
                            </div>
                            <div className="col-md-12"
                                 style={{borderBottom: '2px solid #EEEEEE', marginBottom: '30px'}}></div>
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Allergy Name</label>
                                <input
                                    id="allergyName"
                                    name="allergyName"
                                    className="form-control"
                                    value={formData.allergyName}
                                    onChange={onEdit}
                                />
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Allergy Medication</label>
                                <input
                                    id="allergyMedication"
                                    name="allergyMedication"
                                    className="form-control"
                                    value={formData.allergyMedication}
                                    onChange={onEdit}
                                />
                            </div>

                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Last Attack Date</label>
                                <input
                                    type="date"
                                    name="lastAttackDate"
                                    className="form-control"
                                    id="lastAttackDate"
                                    value={formData.lastAttackDate}
                                    onChange={onEdit}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label"> Duration Before Subsiding</label>
                                <input
                                    id="durationBeforeSubsiding"
                                    name="durationBeforeSubsiding"
                                    className="form-control"
                                    value={formData.durationBeforeSubsiding}
                                    onChange={onEdit}
                                />
                            </div>
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Image</label>
                                <input
                                    type="file"
                                    className="form-control form-control-solid"
                                    name="ImagePath"
                                    id="ImagePath"
                                    onChange={onImageChange}
                                    accept="image/*"
                                />
                            </div>
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Allergy Description</label>
                                <textarea
                                    rows={3}
                                    cols={3}
                                    name="allergyDescription"
                                    className="form-control"
                                    id="allergyDescription"
                                    value={formData.allergyDescription}
                                    onChange={onEdit}
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default waves-effect" data-dismiss="modal">Close
                        </button>
                        {
                            IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={addAllergy}
                                        className="btn btn-danger waves-effect waves-light">{props.btn ?? "submit"}</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}

const mapStateToProps = (state) => {
    return {
        loginData: state.LoginDetails,
    };
};
export default connect(mapStateToProps, null)(Allergy);